/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * The list of error codes used in runtime code of the `forms` package.
 * Reserved error code range: 1000-1999.
 */
export let RuntimeErrorCode;

(function (RuntimeErrorCode) {
  RuntimeErrorCode[RuntimeErrorCode["NO_CONTROLS"] = 1000] = "NO_CONTROLS";
  RuntimeErrorCode[RuntimeErrorCode["MISSING_CONTROL"] = 1001] = "MISSING_CONTROL";
  RuntimeErrorCode[RuntimeErrorCode["MISSING_CONTROL_VALUE"] = 1002] = "MISSING_CONTROL_VALUE";
  RuntimeErrorCode[RuntimeErrorCode["FORM_CONTROL_NAME_MISSING_PARENT"] = 1050] = "FORM_CONTROL_NAME_MISSING_PARENT";
  RuntimeErrorCode[RuntimeErrorCode["FORM_CONTROL_NAME_INSIDE_MODEL_GROUP"] = 1051] = "FORM_CONTROL_NAME_INSIDE_MODEL_GROUP";
  RuntimeErrorCode[RuntimeErrorCode["FORM_GROUP_MISSING_INSTANCE"] = 1052] = "FORM_GROUP_MISSING_INSTANCE";
  RuntimeErrorCode[RuntimeErrorCode["FORM_GROUP_NAME_MISSING_PARENT"] = 1053] = "FORM_GROUP_NAME_MISSING_PARENT";
  RuntimeErrorCode[RuntimeErrorCode["FORM_ARRAY_NAME_MISSING_PARENT"] = 1054] = "FORM_ARRAY_NAME_MISSING_PARENT";
  RuntimeErrorCode[RuntimeErrorCode["WRONG_VALIDATOR_RETURN_TYPE"] = -1101] = "WRONG_VALIDATOR_RETURN_TYPE";
  RuntimeErrorCode[RuntimeErrorCode["NG_VALUE_ACCESSOR_NOT_PROVIDED"] = 1200] = "NG_VALUE_ACCESSOR_NOT_PROVIDED";
  RuntimeErrorCode[RuntimeErrorCode["COMPAREWITH_NOT_A_FN"] = 1201] = "COMPAREWITH_NOT_A_FN";
  RuntimeErrorCode[RuntimeErrorCode["NAME_AND_FORM_CONTROL_NAME_MUST_MATCH"] = 1202] = "NAME_AND_FORM_CONTROL_NAME_MUST_MATCH";
  RuntimeErrorCode[RuntimeErrorCode["NG_MISSING_VALUE_ACCESSOR"] = -1203] = "NG_MISSING_VALUE_ACCESSOR";
  RuntimeErrorCode[RuntimeErrorCode["NGMODEL_IN_FORM_GROUP"] = 1350] = "NGMODEL_IN_FORM_GROUP";
  RuntimeErrorCode[RuntimeErrorCode["NGMODEL_IN_FORM_GROUP_NAME"] = 1351] = "NGMODEL_IN_FORM_GROUP_NAME";
  RuntimeErrorCode[RuntimeErrorCode["NGMODEL_WITHOUT_NAME"] = 1352] = "NGMODEL_WITHOUT_NAME";
  RuntimeErrorCode[RuntimeErrorCode["NGMODELGROUP_IN_FORM_GROUP"] = 1353] = "NGMODELGROUP_IN_FORM_GROUP";
})(RuntimeErrorCode || (RuntimeErrorCode = {}));